import { Map } from 'immutable';
import { takeEvery, put, call, all, select } from 'redux-saga/effects';
import * as tracking from '../tracking/tracking';
import { gettingUserDetails, updateUserDetails } from '../services/backendService';
import { changeLanguage } from './i18n';
import * as auth from '../authService';
import { namespaceActionObject } from './helpers'
import { getAuthToken } from './auth'
import { sendDealInfo } from '../reducers/DealInfo';

// TYPES
export const REDUCER_ACTIONS = namespaceActionObject('USER')({
  SET_USER_DETAILS: 'SET_USER_DETAILS',
  CLEAR_USER_DETAILS: 'CLEAR_USER_DETAILS',
  PHONE_STATUS: 'PHONE_STATUS',
  FETCH_USER_DETAILS_PENDING: 'FETCH_USER_DETAILS_PENDING',
  FETCH_USER_DETAILS_ERROR: 'FETCH_USER_DETAILS_ERROR',
  FETCH_USER_DETAILS_SUCCESS: 'FETCH_USER_DETAILS_SUCCESS',
  FETCH_USER_DETAILS: 'FETCH_USER_DETAILS',
  EDIT_USER_DETAILS : 'EDIT_USER_DETAILS',
  EDIT_USER_DETAILS_PENDING : 'EDIT_USER_DETAILS_PENDING',
  EDIT_USER_DETAILS_SUCCESS : 'EDIT_USER_DETAILS_SUCCESS',
  EDIT_USER_DETAILS_ERROR : 'EDIT_USER_DETAILS_ERROR',
});

export const REDUCER_STATUS = {
  USER_DETAIL_NOT_ASKED: 'USER_DETAIL_NOT_ASKED',
  USER_DETAIL_ASKED: 'USER_DETAIL_ASKED',
  USER_DETAIL_ERR: 'USER_DETAIL_ERR',
  USER_DETAIL_SENT: 'USER_DETAIL_SENT',
  LOGGED_IN: 'LOGGED_IN',
  EDIT_USER_DETAILS_NOT_ASK: 'EDIT_USER_DETAILS_NOT_ASK',
  EDIT_USER_DETAILS_ASK: 'EDIT_USER_DETAILS_ASK',
  EDIT_USER_DETAILS_SUCCESS: 'EDIT_USER_DETAILS_SUCCESS',
  EDIT_USER_DETAILS_ERRROR: 'EDIT_USER_DETAILS_ERRROR'
}

// ACTIONS

export const fetchUserDetails = () => ({
  type: REDUCER_ACTIONS.FETCH_USER_DETAILS
});

export const fetchUserDetailsPending = () => ({
  type: REDUCER_ACTIONS.FETCH_USER_DETAILS_PENDING,
})

export const fetchUserDetailsError = () => ({
  type: REDUCER_ACTIONS.FETCH_USER_DETAILS_ERROR,
})

export const fetchUserDetailsSuccess = (userData) => ({
  type: REDUCER_ACTIONS.FETCH_USER_DETAILS_SUCCESS,
  payload: userData
})

export const setUserDetails = (data, status, alreadyCreated) => ({
  type: REDUCER_ACTIONS.SET_USER_DETAILS,
  payload: { data, status, alreadyCreated }
});

export const clearUserDetails = () => ({
  type: REDUCER_ACTIONS.CLEAR_USER_DETAILS
});

export const editUserDetails = (data) => {
  return{
  type: REDUCER_ACTIONS.EDIT_USER_DETAILS,
  payload: data
  };
}

export const editUserDetailsPending = () => ({
  type: REDUCER_ACTIONS.EDIT_USER_DETAILS_PENDING
})

export const editUserDetailsError = (error) => ({
  type: REDUCER_ACTIONS.EDIT_USER_DETAILS_ERROR,
  payload: error
})

export const editUserDetailsSuccess = (newUserDetail) => ({
  type: REDUCER_ACTIONS.EDIT_USER_DETAILS_SUCCESS,
  payload: newUserDetail
})



// SAGAS

export function* watchFetchUserDetails() {
  yield takeEvery(REDUCER_ACTIONS.FETCH_USER_DETAILS, fetchingUserData);
}

export function* watchEditUserDetails() {
  yield takeEvery(REDUCER_ACTIONS.EDIT_USER_DETAILS, changeUserDetails);
}

export function* fetchingUserData() {
  try {
    yield put(fetchUserDetailsPending());
    const jwtToken = yield select(getAuthToken);
    const tokenPayload = auth.parseJwtToken(jwtToken)
    // normalize the +972 to 0, because israeli numbers are saved without country prefix on airtable
    const phone = tokenPayload.mobilePhone.replace(/^\+972/, '0');

    const userDetails = yield call(gettingUserDetails, `/members/byPhone/${phone}`, jwtToken);
    let { languageCode, gender } = userDetails.data;
    languageCode = gender === 'MALE' ? languageCode : languageCode + '_female';

    yield all([
      call(tracking.identifyUser, userDetails, tokenPayload),
      call(tracking.updateUserDetails, userDetails),
    ]);
    yield put(fetchUserDetailsSuccess(userDetails));
    yield put(sendDealInfo(userDetails.data.id))
    yield put(changeLanguage(languageCode));
  } catch (error) {
    yield put(fetchUserDetailsError(error))
  }
}

export function* changeUserDetails(action) {
  try {
    yield put(editUserDetailsPending());
    const token = yield select(getAuthToken)
    const data = yield [
      call(updateUserDetails, action.payload, token),
      call(tracking.updateUserDetails, action.payload)
    ];
    yield put(editUserDetailsSuccess(data[0].data))
  } catch (error) {
    console.warn("Failed while update the user detail information", error);
    yield put(editUserDetailsError(error))
  }
}


// STATE MAPPERS
export const getUserDetails = (state) => state.userDetails.get('userDetails');
export const isUserDetailsPending = (state) => state.userDetails.get('status') === REDUCER_STATUS.USER_DETAIL_ASKED;
export const didUserDetailsFailed = (state) => state.userDetails.get('status') === REDUCER_STATUS.USER_DETAIL_ERR;
export const didUserDetailsSuccess = (state) => state.userDetails.get('status') === REDUCER_STATUS.USER_DETAIL_SENT;
export const didEditUserDetailsSuccess = (state) => state.userDetails.get("status") === REDUCER_STATUS.EDIT_USER_DETAILS_SUCCESS;



const initState = Map({
  status: REDUCER_STATUS.USER_DETAIL_NOT_ASKED,
  data: ''
});

export default (state = initState, action) => {
  const { type, payload } = action
  switch (type) {
    case REDUCER_ACTIONS.FETCH_USER_DETAILS_PENDING:
      return state.set("status", REDUCER_STATUS.USER_DETAIL_ASKED);
    case REDUCER_ACTIONS.FETCH_USER_DETAILS_ERROR:
      return state.set('status', REDUCER_STATUS.USER_DETAIL_ERR);
    case REDUCER_ACTIONS.FETCH_USER_DETAILS_SUCCESS:
      return state.merge({ status: REDUCER_STATUS.USER_DETAIL_SENT, userDetails: payload });
    case REDUCER_ACTIONS.EDIT_USER_DETAILS_PENDING:
      return state.set("status", REDUCER_STATUS.EDIT_USER_DETAILS_PENDING);
    case REDUCER_ACTIONS.EDIT_USER_DETAILS_ERROR:
      return state.merge({ status: REDUCER_STATUS.EDIT_USER_DETAILS_ERRROR, error: payload });
    case REDUCER_ACTIONS.EDIT_USER_DETAILS_SUCCESS :
      return state.merge({ status: REDUCER_STATUS.EDIT_USER_DETAILS_SUCCESS, editUserDetails: payload})
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userDetails.js